module.exports = __webpack_public_path__ + "static/media/16.1.7002b37d.png";